import { connect } from "react-redux";

import { getJobList } from "../Jobs/jobsActions";
import { getOrganizationMembersShortList } from "../Projects/projectsActions";
import {
  deleteWorkOrderJob,
  updateJobRequest,
} from "../WorkOrderNew/workOrderActions";
import { getOnboardingFeatures, dismissOnboardingFeature } from "../AppOnboarding/appOnboardingActions";
import ShiftSchedule from "./ShiftSchedule";
//Actions
import {
  deleteShifts,
  editShift,
  getJobShiftsList,
  getOfficeShiftsList,
} from "./shiftScheduleActions";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  officeShiftsList: state.schedule.officeShiftsList,
  jobShiftsList: state.schedule.jobShiftsList,
  deleteCallback: state.schedule.deleteCallback,
  editCallback: state.schedule.editCallback,
  editIsLoading: state.schedule.editIsLoading,
  createdShiftInfo: state.schedule.createdShiftInfo,
  jobShortList: state.jobs.jobShortList,
  deleteJobCallback: state.workorder.deleteJobCallback,

  isLoading: state.schedule.isLoading,
  isBackgroundRefreshing: state.schedule.isBackgroundRefreshing,
  jobListIsLoading: state.schedule.jobListIsLoading,
  createIsLoading: state.schedule.createIsLoading,
  deleteIsLoading: state.schedule.deleteIsLoading,
  workOrderJobDeleteIsLoading: state.workorder.workOrderJobDeleteIsLoading,
  jobUpdate: state.workorder.jobUpdate,
  // for job container
  isLoadingJobs: state.jobs.isLoadingJobs,
  totaljobsCount: state.jobs.totaljobsCount,
  pageSizeJob: state.jobs.pageSizeJob,
  jobList: state.jobs.jobList,
  reloadJobList: state.jobs.reloadJobList,
  // for assignee dropdown
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  // for app onboarding features
  appOnboardingFeatures: state.appOnboarding?.features,
  appOnboardingIsFeaturesLoading: state.appOnboarding?.isFeaturesLoading,
  appOnboardingState: state.appOnboarding,
  dismissFeatureLoading: state.appOnboarding?.dismissFeatureLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOfficeShiftsList: details => dispatch(getOfficeShiftsList({ ...details })),
  getJobShiftsList: details => dispatch(getJobShiftsList({ ...details })),
  deleteShifts: details => dispatch(deleteShifts({ ...details })),
  deleteWorkOrderJob: details => dispatch(deleteWorkOrderJob({ ...details })),
  getJobList: params => dispatch(getJobList(params)),
  editShift: params => dispatch(editShift(params)),
  updateJobRequest: details => dispatch(updateJobRequest({ ...details })),
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  getOnboardingFeatures: organizationId =>
    dispatch(getOnboardingFeatures(organizationId)),
  dismissOnboardingFeature: (organizationId, featureName) =>
    dispatch(dismissOnboardingFeature(organizationId, featureName)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(ShiftSchedule);
